/**
 * StreamingLayout -- layout route wrapping all /streaming/dashboard/* pages.
 *
 * A thin alias over the shared `StreamingFlyoutHost`: it mounts the flyout
 * apparatus (Analytics / Settings / Logs panels + mirror dock) unconditionally,
 * because every /streaming/dashboard/* route is already admin-gated. The same
 * host is mounted with `adminOnly` on the standalone Media Requests routes so an
 * admin gets the settings flyout in place there too.
 */
import { StreamingFlyoutHost } from "./StreamingFlyoutHost";

export const StreamingLayout = () => <StreamingFlyoutHost />;
